export default "__VITE_PUBLIC_ASSET__20ee1229__"